import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { HomeIcon, PlugIcon, ThermometerIcon, SettingsIcon, HelpCircleIcon, UsersIcon, LogOutIcon, SparklesIcon, WalletIcon, ZapIcon } from 'lucide-react';
export function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  return <div className="hidden md:flex flex-col w-64 bg-white border-r border-gray-200 py-6 px-3" data-id="element-456">
      <div className="px-4 mb-8" data-id="element-457">
        <div className="flex items-center gap-2 mb-1" data-id="element-458">
          <div className="w-10 h-10 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center" data-id="element-459">
            <ZapIcon size={20} className="text-white" data-id="element-460" />
          </div>
          <div data-id="element-461">
            <h1 className="text-xl font-bold text-green-600" data-id="element-462">WattWise</h1>
            <p className="text-gray-500 text-xs" data-id="element-463">Smart Energy System</p>
          </div>
        </div>
      </div>
      <nav className="flex-1" data-id="element-464">
        <div className="space-y-1" data-id="element-465">
          <button onClick={() => navigate('/')} className={`flex items-center w-full px-4 py-2 rounded-lg ${isActive('/') ? 'text-gray-800 bg-green-50' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-466">
            <HomeIcon size={18} className={`mr-3 ${isActive('/') ? 'text-green-600' : 'text-gray-500'}`} data-id="element-467" />
            Dashboard
          </button>
          <button onClick={() => navigate('/scenes')} className={`flex items-center w-full px-4 py-2 rounded-lg ${isActive('/scenes') ? 'text-gray-800 bg-green-50' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-468">
            <SparklesIcon size={18} className={`mr-3 ${isActive('/scenes') ? 'text-green-600' : 'text-gray-500'}`} data-id="element-469" />
            Scenes
          </button>
          <button onClick={() => navigate('/budget')} className={`flex items-center w-full px-4 py-2 rounded-lg ${isActive('/budget') ? 'text-gray-800 bg-green-50' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-470">
            <WalletIcon size={18} className={`mr-3 ${isActive('/budget') ? 'text-green-600' : 'text-gray-500'}`} data-id="element-471" />
            Budget
          </button>
          <button className="flex items-center w-full px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg" data-id="element-472">
            <PlugIcon size={18} className="mr-3 text-gray-500" data-id="element-473" />
            Devices
          </button>
          <button className="flex items-center w-full px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg" data-id="element-474">
            <ThermometerIcon size={18} className="mr-3 text-gray-500" data-id="element-475" />
            Climate
          </button>
          <button className="flex items-center w-full px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg" data-id="element-476">
            <SettingsIcon size={18} className="mr-3 text-gray-500" data-id="element-477" />
            Settings
          </button>
        </div>
        <div className="mt-8 pt-4 border-t border-gray-200 space-y-1" data-id="element-478">
          <button className="flex items-center w-full px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg" data-id="element-479">
            <UsersIcon size={18} className="mr-3 text-gray-500" data-id="element-480" />
            Account
          </button>
          <button className="flex items-center w-full px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg" data-id="element-481">
            <HelpCircleIcon size={18} className="mr-3 text-gray-500" data-id="element-482" />
            Help & Support
          </button>
          <button className="flex items-center w-full px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg" data-id="element-483">
            <LogOutIcon size={18} className="mr-3 text-gray-500" data-id="element-484" />
            Log Out
          </button>
        </div>
      </nav>
    </div>;
}